interface State {
  SummaryDetailsList: any[];
  SummaryDetailCount: number;
}

const initialState: State = {
  SummaryDetailsList: [],
  SummaryDetailCount: 0,
};

export const SummaryDetailReducer = (
  state: State = initialState,
  action: any,
): State => {
  switch (action.type) {
    case "GET_SUMMARY_DETAILS_DATA":
      return {
        ...state,
        SummaryDetailsList:
          action.payload.page === 1
            ? action.payload.data
            : [...state.SummaryDetailsList, ...action.payload.data],
        SummaryDetailCount: action.payload.count,
      };

    case "UPDATE_SUMMARY_DETAILS_DATA":
      return {
        ...state,
        SummaryDetailsList: state.SummaryDetailsList.map((item: any) =>
          item._id === action.payload._id ? action.payload : item,
        ),
      };

    case "CLEAR_SUMMARY_DETAILS_DATA":
      return {
        ...state,
        SummaryDetailsList: [],
        SummaryDetailCount: 0,
      };

    default:
      return state;
  }
};
